















































































































import { Component, Mixins, Model } from 'vue-property-decorator'

import { StepUnit } from '../../../../components/PeriodSimplifier/types'
import SwitchInput from '../../../Pi/fields/SwitchInput/SwitchInput.vue'
import TimeUnitInput from '../../../Pi/fields/TimeUnitInput/TimeUnitInput.vue'
import { FieldData } from '../../../Pi/types'
import { TagData } from '../../../Tags/types'
import MessageSettingsProps from './mixins/mixins'
import { MessageSettingsData } from './types'

@Component({
  components: {
    SwitchInput,
    TimeUnitInput,
  },
  data() {
    return {
      StepUnit
    }
  },
})
export default class MessageSettings extends Mixins<MessageSettingsProps>(MessageSettingsProps) {
  @Model('input', { type: Object }) readonly model!: MessageSettingsData

  checkTariffTags(tariff: string): Array<TagData> | null {
    if (this.options && this.options[tariff]) {
      return this.options[tariff]
    }
    return null
  }

  isControlVisible(key: keyof MessageSettingsData):boolean {
    if (this.settingsStructure) {
      return this.settingsStructure[key] !== undefined
    }

    return this.model[key] !== undefined
  }

  inputConfig(fieldData: FieldData): FieldData {
    fieldData.setter = (value): void => {
      this.$set(fieldData.model, fieldData.key as string, value)
      this.$emit('input', fieldData.model)
    }
    return this.inputConfigFn ? this.inputConfigFn(fieldData) as FieldData : fieldData
  }
}
